import { Unionize } from "fond/types";
import { Attachment } from "fond/types/attachment";

export type Sort = { colId: keyof Attachment; sort: "asc" | "desc" };

export const ViewMode = ["list", "gallery"] as const;
export type ViewMode = Unionize<typeof ViewMode>;

/**
 * Additional context for the file viewer, used for tracking purposes.
 */
export const FileViewerTrackingContext = ["feature-attachments"] as const;
export type FileViewerTrackingContext = Unionize<typeof FileViewerTrackingContext>;
